import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { StatsService } from '../../providers/stats.service';
import { ExercicesProvider } from '../../../exercices/providers/exercices-provider';
import * as Highcharts from 'highcharts';
import BaseStats from '../base-stats';
import { TranslateService } from '@ngx-translate/core';
import { ExercicesExerciceViewDialogComponent } from '../../../exercices/components/exercice-view-dialog/exercice-view-dialog';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Exercise } from "../../../common/models/stats/exercise";
import { StatsPieChartComponent } from "../../components/stats-pie-chart/stats-pie-chart.component";
import { MetricsItemComponent } from "../../components/metrics-item/metrics-item";
import { StatsEmptyComponent } from "../../components/stats-empty/stats-empty.component";
import { NgForOf, NgIf, PercentPipe } from "@angular/common";

@Component({
  selector: 'app-exercises-performed-container',
  templateUrl: './exercises-performed-container.component.html',
  styleUrls: ['./exercises-performed-container.scss', '../../components/metrics-item/metrics-item-list.scss'],
  standalone: true,
  imports: [
    StatsPieChartComponent,
    MetricsItemComponent,
    StatsEmptyComponent,
    NgForOf,
    NgIf,
    PercentPipe
  ],
  providers: [StatsService]
})
export class ExercisesPerformedContainerComponent extends BaseStats implements OnInit, OnDestroy {
    public exercises: Exercise[] = [];
    public exercisesLoaded: EventEmitter<any> = new EventEmitter();
    private subscriptions: Subscription[] = [];

    constructor(
        private statsProvider: StatsService,
        private exerciseProvider: ExercicesProvider,
        private dialog: MatDialog,
    ) {
        super();
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this.exercisesLoaded.subscribe((exercises: Exercise[]) => {
                const exercisesData = exercises.map((exercise) => ({
                    name: exercise.exerciseName,
                    y: this.percent(exercise.occurrence, exercise.totalOccurrence),
                    occurrence: exercise.occurrence
                }));
                this.options = {
                    tooltip: {
                        pointFormatter(this:any): string {
                            return '<strong>' + Highcharts.numberFormat(this.y, 1) + ' %</strong><br />' +
                                '<strong>' + this.options.occurrence + ' x</strong>'
                            ;
                        }
                    },
                    series: [{
                        data: exercisesData
                    }]
                };
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }

    public onShowClicked(exercise: any): void {
        this.exerciseProvider.getExerciceRow(this.organization, exercise.id).subscribe({
            next: (row) => {
                this.dialog.open(ExercicesExerciceViewDialogComponent, {
                    data: {
                        exerciceRow: row,
                        organization: this.organization
                    }
                });
            }
        });
    }

    protected populateData() {
        this.subscriptions.push(
            this.statsProvider.getExercisesPerformedDataByDate(this.organization, this.athlete, this.dateFrom, this.dateTo)
                .subscribe((exercises) => {
                    this.exercises = exercises;
                    this.loaded = true;
                    this.exercisesLoaded.emit(exercises);
                })
        );
    }

    protected getTitle() {
        return 'StatsExercises';
    }
}
